// Module
var code = "<main class=\"tc-viewport\" :class=\"classes\">\n  <tc-sidebar v-if=\"isMobileScreen\" />\n  <tc-topbar logoWidth=\"100px\" logoHeight=\"18px\" v-if=\"!hideTopbar\" />\n  <article class=\"tc-viewport-content\">\n    <slot></slot>\n  </article>\n  <tc-footer />\n</main>\n";
// Exports
export default code;